import axios from 'axios';
import { DRAFT_AUDIT } from 'src/api';
import { handleErrorToast } from 'src/components/molecules';
import { AuditActions, AuditEntry } from 'src/types';

export const fetchAuditLog = async (
  reportID: string,
  setAuditLog: React.Dispatch<React.SetStateAction<AuditEntry[]>>,
) => {
  try {
    const actionsToDisplay = Object.keys(AuditActions);
    const response = await axios.get(DRAFT_AUDIT(reportID));
    setAuditLog(
      response.data.data.filter((entry: AuditEntry) =>
        actionsToDisplay.includes(entry.action),
      ),
    );
  } catch (error) {
    handleErrorToast({ toastMessage: 'Could not get report audit log' });
  }
};
